import { convertToOptionsCollection } from 'utilities/collection';

import queryParameterNames from 'constants/query-parameter-names';

export function buildDefaultFromEmailAddress(user) {

  return {
    label: user.emailIdentity.fromName,
    value: user.emailIdentity.fromEmailAddress,
    object: {
      ...user.emailIdentity,
      _id: user._id
    }
  };

}

function labelBuilder(divisionIdentity) {

  return divisionIdentity.fromName;

}

export function buildFromEmailAddressOptions(user, divisionIdentities) {

  const options = [
    buildDefaultFromEmailAddress(user),
    ...convertToOptionsCollection(divisionIdentities, 'fromName', 'fromEmailAddress', labelBuilder)
  ];

  return options;

}

export function getActiveTagNames(searchParameters) {

  const queryString = searchParameters.get(queryParameterNames.TAGS) || '';

  if (queryString === '') {
    return [];
  }

  return queryString.split(',');

}